<h1 mat-dialog-title>Pendency</h1>
<div mat-dialog-content>
  <mat-button-toggle-group
    class="my-2"
    #group="matButtonToggleGroup"
    [value]="selectedVal"
    (change)="onValChange(group.value)"
  >
    <mat-button-toggle value="Tabular" aria-label="Text align left">
      Tabular
    </mat-button-toggle>
    <mat-button-toggle value="Graphical" aria-label="Text align left">
      Graphical
    </mat-button-toggle>
  </mat-button-toggle-group>
  <div>
    <dg-timeline
      *ngIf="selectedVal != ''"
      [activeToggle]="selectedVal"
      [reqobjectTimeline]="case"
    ></dg-timeline>
  </div>
</div>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
